import React, { useId, useState } from 'react';
import { Input } from 'components/ui/input';
import { Label } from 'components/ui/label';
import { useLanguage } from 'lib/i18n';

export const TrackingEmailField = ({ accountEmail, value, onChange }) => {
  const id = useId();
  const { t } = useLanguage();
  const [useAccountEmail, setUseAccountEmail] = useState(false);
  const [previousEmail, setPreviousEmail] = useState('');
  return (
    <div>
      <Label htmlFor={`${id}-email`}>{t('delivery.recipientEmail')}</Label>
      <Input id={`${id}-email`} type="email" value={value} readOnly={useAccountEmail} onChange={event => onChange(event.target.value)} placeholder="destinataire@email.com" aria-describedby={`${id}-notice`} data-testid="delivery-recipient-email-input" />
      <label className="mt-2 flex min-h-11 cursor-pointer items-center gap-2 rounded-lg border bg-secondary/40 px-3 py-2 text-sm">
        <input type="checkbox" className="h-4 w-4 shrink-0 accent-primary" checked={useAccountEmail} disabled={!accountEmail} data-testid="delivery-use-my-email-checkbox" onChange={event => {
          const checked = event.target.checked;
          if (checked) {
            setPreviousEmail(value);
            onChange(accountEmail);
          } else onChange(previousEmail);
          setUseAccountEmail(checked);
        }} />
        <span>{t('delivery.useMyTrackingEmail')}{accountEmail && <span className="block break-all text-xs text-muted-foreground">{accountEmail}</span>}</span>
      </label>
      <p id={`${id}-notice`} className="mt-1 text-xs text-muted-foreground">{useAccountEmail ? t('delivery.myTrackingEmailNotice') : t('delivery.recipientNotice')}</p>
    </div>
  );
};